/**
 * Redux store for updating completion status from userInfo.
 */

import {
    applyMiddleware,
    createStore,
    type Dispatch,
    type Middleware,
    type Store,
} from "redux";

import {createCompose} from "@khan/util-redux-create-compose";

import userInfoReducer, {
    defaultState,
    type Action,
    type State,
} from "./user-info-reducer.ts";
import {defaultCallbacks, handleSideEffects} from "./user-info-side-effects.ts";

const compose = createCompose({
    reduxDevtoolsOptions: {
        name: "User Info",
    },
});

const sideEffectHandler = handleSideEffects(defaultCallbacks);

const sideEffectsMiddleware: Middleware<State, Action, Dispatch<Action>> =
    (store) => (next: unknown) => (action: unknown) => {
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const result = next(action);
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Action'.
        sideEffectHandler(next, action, store.getState());
        return result;
    };

// TODO(jared): Merge with the Modal Navigator Store
// @ts-expect-error - TS2558 - Expected 4 type arguments, but got 3.
export default createStore<State, Action, Dispatch<Action>>(
    userInfoReducer,
    defaultState,
    compose(applyMiddleware(sideEffectsMiddleware)),
    // @ts-expect-error - TS2707 - Generic type 'Store<S, A>' requires between 0 and 2 type arguments.
) as Store<State, Action, Dispatch<Action>>;
